var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogotipoSpotify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logotipo-spotify",
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.166,
    height: 36.266,
    viewBox: "0 0 121.166 36.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68112",
    "data-name": "Group 68112",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158494",
    "data-name": "Path 158494",
    d: "M47.726,188.083A18.132,18.132,0,1,0,65.9,206.215,18.152,18.152,0,0,0,47.726,188.083Zm8.333,26.153a1.133,1.133,0,0,1-1.557.376c-4.267-2.6-9.638-3.19-15.963-1.748a1.13,1.13,0,1,1-.5-2.2c6.922-1.579,12.859-.9,17.648,2.021A1.129,1.129,0,0,1,56.059,214.236Zm2.224-4.937a1.419,1.419,0,0,1-1.949.466c-4.883-3-12.329-3.863-18.106-2.113a1.414,1.414,0,1,1-.823-2.7,26.558,26.558,0,0,1,20.412,2.409A1.412,1.412,0,0,1,58.282,209.3Zm.192-5.141c-5.857-3.471-15.518-3.79-21.11-2.1a1.7,1.7,0,1,1-.987-3.246c6.419-1.944,17.088-1.569,23.831,2.426a1.7,1.7,0,1,1-1.735,2.917Z",
    transform: "translate(-29.555 -188.083)",
    fill: "#1ed760"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68115",
    "data-name": "Group 68115",
    transform: "translate(41.824 8.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68113",
    "data-name": "Group 68113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158495",
    "data-name": "Path 158495",
    d: "M193.493,231.43c-3.137-.747-3.7-1.271-3.7-2.372,0-1.04.981-1.74,2.441-1.74a7.14,7.14,0,0,1,4.288,1.626.206.206,0,0,0,.155.038.2.2,0,0,0,.136-.084l1.532-2.155a.205.205,0,0,0-.039-.279,9.28,9.28,0,0,0-6.025-2.083c-3.388,0-5.754,2.028-5.754,4.931,0,3.112,2.041,4.215,5.568,5.065,3,.69,3.509,1.268,3.509,2.3,0,1.145-1.024,1.857-2.673,1.857a7.215,7.215,0,0,1-5-2.06.215.215,0,0,0-.151-.049.2.2,0,0,0-.141.072l-1.718,2.04a.2.2,0,0,0,.02.285,10.253,10.253,0,0,0,6.915,2.647c3.65,0,6.009-1.99,6.009-5.071C198.874,233.8,197.315,232.358,193.493,231.43Z",
    transform: "translate(-185.88 -223.03)",
    fill: "#1ed760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158496",
    "data-name": "Path 158496",
    d: "M245.685,239.217a4.926,4.926,0,0,0-3.95,1.9v-1.434a.206.206,0,0,0-.205-.206H238.72a.206.206,0,0,0-.205.206v15.937a.205.205,0,0,0,.205.205h2.809a.205.205,0,0,0,.205-.205v-5.03a5.05,5.05,0,0,0,3.95,1.784c2.94,0,5.916-2.258,5.916-6.575S248.625,239.217,245.685,239.217Zm2.65,6.577c0,2.2-1.357,3.733-3.3,3.733a3.752,3.752,0,0,1,0-7.465C246.946,242.062,248.335,243.631,248.335,245.794Z",
    transform: "translate(-224.433 -233.905)",
    fill: "#1ed760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158497",
    "data-name": "Path 158497",
    d: "M297.455,239.217a6.59,6.59,0,1,0,6.728,6.577A6.618,6.618,0,0,0,297.455,239.217Zm0,10.332a3.569,3.569,0,0,1-3.532-3.756,3.484,3.484,0,0,1,3.486-3.71,3.58,3.58,0,0,1,3.555,3.757A3.494,3.494,0,0,1,297.455,249.549Z",
    transform: "translate(-262.659 -233.905)",
    fill: "#1ed760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158498",
    "data-name": "Path 158498",
    d: "M349.772,230.954h-3.091V227.8a.205.205,0,0,0-.205-.205h-2.809a.206.206,0,0,0-.206.205v3.154H342.11a.205.205,0,0,0-.2.206v2.409a.205.205,0,0,0,.2.205h1.351v6.234c0,2.519,1.257,3.8,3.735,3.8a5.134,5.134,0,0,0,2.632-.654.2.2,0,0,0,.1-.178v-2.294a.206.206,0,0,0-.3-.184,3.546,3.546,0,0,1-1.649.4c-.9,0-1.3-.408-1.3-1.323v-5.795h3.091a.205.205,0,0,0,.2-.205V231.16A.205.205,0,0,0,349.772,230.954Z",
    transform: "translate(-300.163 -225.385)",
    fill: "#1ed760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158499",
    "data-name": "Path 158499",
    d: "M398.618,226.954v-.387c0-1.139.438-1.648,1.42-1.648a4.75,4.75,0,0,1,1.583.292.205.205,0,0,0,.27-.2v-2.362a.205.205,0,0,0-.145-.2,7.721,7.721,0,0,0-2.335-.335c-2.595,0-3.966,1.458-3.966,4.215v.594H394.1a.206.206,0,0,0-.206.205v2.422a.207.207,0,0,0,.206.205h1.349v9.616a.205.205,0,0,0,.2.205h2.809a.206.206,0,0,0,.206-.205v-9.616h2.623l4.018,9.613c-.456,1.01-.9,1.211-1.517,1.211a3.244,3.244,0,0,1-1.549-.438.211.211,0,0,0-.164-.015.205.205,0,0,0-.121.111L401,242.327a.2.2,0,0,0,.088.265,5.926,5.926,0,0,0,3,.766c2.074,0,3.221-.964,4.232-3.558l4.874-12.567a.2.2,0,0,0-.191-.28h-2.924a.206.206,0,0,0-.195.138l-3,8.539-3.281-8.545a.205.205,0,0,0-.192-.132Z",
    transform: "translate(-338.238 -221.373)",
    fill: "#1ed760"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28219",
    "data-name": "Rectangle 28219",
    width: 3.221,
    height: 12.641,
    rx: 0.769,
    transform: "translate(51.121 5.569)",
    fill: "#1ed760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158500",
    "data-name": "Path 158500",
    d: "M377.512,219.319a2.01,2.01,0,1,0,2.015,2.01A2.013,2.013,0,0,0,377.512,219.319Z",
    transform: "translate(-324.766 -219.319)",
    fill: "#1ed760"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68114",
    "data-name": "Group 68114",
    transform: "translate(75.379 5.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158501",
    "data-name": "Path 158501",
    d: "M469.6,244.044a1.978,1.978,0,1,1,1.987-1.984A1.967,1.967,0,0,1,469.6,244.044Zm.01-3.76a1.781,1.781,0,1,0,1.769,1.776A1.766,1.766,0,0,0,469.615,240.284Zm.438,1.979.559.781h-.472l-.5-.717h-.433v.717h-.395v-2.071h.925c.482,0,.8.246.8.66A.618.618,0,0,1,470.053,242.263Zm-.334-.934h-.515v.655h.515c.257,0,.41-.125.41-.328S469.977,241.328,469.72,241.328Z",
    transform: "translate(-467.628 -240.088)",
    fill: "#1ed760"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotipoSpotify);
export default __webpack_public_path__ + "static/media/logotipo-spotify.dc48ea3c60a60f066b854dfcc884c7f7.svg";
export { ForwardRef as ReactComponent };